import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["close", "actionable"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
    this.lastActiveElement = document.activeElement
    this.element.setAttribute("aria-hidden", "false")
    this.element.addEventListener('keydown', this.handleKeydown)
    // Focus the first actionable element when modal opens
    requestAnimationFrame(() => this.focusFirstActionable())
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.handleKeydown)
    this.element.setAttribute("aria-hidden", "true")
    // Restore focus to the element that opened the modal
    if (this.lastActiveElement && typeof this.lastActiveElement.focus === "function") {
      this.lastActiveElement.focus()
    }
  }

  focusFirstActionable() {
    const first = this.actionableTargets[0]
    if (first) first.focus()
  }

  handleKeydown(event) {
    // Query actionable elements dynamically in case modal content changes
    const focusable = this.actionableTargets
    if (!focusable.length) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    // Trap focus inside modal
    if (event.key === "Tab") {
      if (event.shiftKey) {
        if (document.activeElement === first) {
          last.focus()
          event.preventDefault()
        }
      } else {
        if (document.activeElement === last) {
          first.focus()
          event.preventDefault()
        }
      }
    }

    // Close modal on Escape
    if (event.key === "Escape") {
      this.close()
    }

    // Space or Enter on actionable elements
    if ((event.key === " " || event.key === "Enter") && focusable.includes(document.activeElement)) {
      const el = document.activeElement
      if (el.tagName.toLowerCase() === "a") {
        // For links, trigger click on Space (Enter already works)
        if (event.key === " ") {
          event.preventDefault()
          el.click()
        }
      }
    }
  }

  close() {
    this.element.style.display = 'none'
    this.element.setAttribute("aria-hidden", "true")
  }
}
